import ApiEndpoints from "../../endpoints";
import type * as models from "./index.types.ts";
import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../../@bizkeytech/base/core";
import {CancelToken} from "axios";

/**@inheritDoc*/
export class InventoryController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Autocomplete for parts.
     *
     * @param request           The request to autocomplete parts.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async autocomplete(request: models.InventoryAutocompleteRequest, cancelToken?: CancelToken): models.InventoryAutocompleteResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.inventory.autoComplete,
            cancelToken: cancelToken,
            params: request,
            showErrorToast: false,
        });
    }

    /**
     * Validates parts.
     *
     * @param request           The request to validate parts.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async validateParts(request: models.ValidatePartsRequest, cancelToken?: CancelToken): models.ValidatePartsResponse {
        return this.executor?.execute({
            method: ApiMethods.post,
            url: ApiEndpoints.inventory.validateParts,
            cancelToken: cancelToken,
            data: request,
            showErrorToast: false,
        });
    }

    //getPartsUsingRawMaterial

    /**
     * Get parts using raw material.
     *
     * @param request           The request to get parts using raw material.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async getPartsUsingRawMaterial(request: models.GetPartsUsingRawMaterialRequest, cancelToken?: CancelToken): models.GetPartsUsingRawMaterialResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.inventory.getPartsUsingRawMaterial,
            cancelToken: cancelToken,
            params: request,
            showErrorToast: false,
        });
    }

}


export type * from './index.types.ts';
export default InventoryController;